import { Component, Vue } from 'vue-property-decorator';

@Component({})
export default class CurrentUserService extends Vue {
  get isUser(): boolean {
    return this.$store.getters['currentUser/roleUser'];
  }

  get isManager(): boolean {
    return this.$store.getters['currentUser/roleManager'];
  }

  get isAdmin(): boolean {
    return this.$store.getters['currentUser/roleAdmin'];
  }

}
